import React, { useEffect, useState } from "react";
import "./AuditionRounds.css";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { Tab, Nav } from "react-bootstrap";
import ReUseableSingleRoundTab from "../../Reuseable/ReUseableSingleRoundTab";
import AuditionVideoResult from "../../Audition_static/Audition_admin/AuditionVideoResult";
import AuditionRoundJudgeAssessmentResult from "./AuditionRoundJudgeAssessmentResult";
import AuditionLiveRoundJudgeAssessment from "./AuditionLiveRoundJudgeAssessment";
import LoaderPost from "../../Reuseable/LoaderPost";

const AuditionJuryMarkedVideoByRound = () => {
  const [videoType, setVideoType] = useState("general");
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [activeRound, setActiveRound] = React.useState(0);
  const [event, setEvent] = useState({});
  const [judges, setJudges] = useState([]);
  const [rounds, setRounds] = useState([]);
  const history = useHistory();

  const [roundInfo, setRoundInfo] = useState({});
  const [roundUsersb, setRoundUsersB] = useState([]);
  const [roundUsersc, setRoundUsersC] = useState([]);
  const [secondaryJuryGroup, setSecondaryJuryGroups] = useState([]);
  const [mainJury, setMainJury] = useState([]);

  const [isVideoAlreadyAssignedRan, setIsVideoAlreadyAssignedRan] = useState(
    []
  );
  const [isVideoAlreadyAssignedPer, setIsVideoAlreadyAssignedPer] = useState(
    []
  );

  const handleAppealedVideos = () => {
    setVideoType("appeal");
  };

  const handleGeneralVideos = () => {
    setVideoType("general");
  };
  const getRoundInstruction = () => {
    if (event?.id && activeRound && videoType) {
      axios.get("/sanctum/csrf-cookie").then((response) => {
        axios
          .get(
            `/api/audition-admin/audition/get-round-info/${event?.id}/${activeRound}/${videoType}`
          )
          .then((res) => {
            if (res.data.status === 200) {
              setRoundInfo(res.data?.round_info);
              setRoundUsersB(res.data?.group_b_videos);
              setRoundUsersC(res.data?.group_c_videos);
              setMainJury(res.data?.mainJury);
              setIsVideoAlreadyAssignedRan(res.data?.isVideoAlreadyAssignedRan);
              setIsVideoAlreadyAssignedPer(res.data?.isVideoAlreadyAssignedPer);
              setSecondaryJuryGroups(res.data.juriesByGroup);
            }
            console.log(res.data);
            setLoading(false);
          });
      });
    }
  };

  const fetchAuditionDetails = () => {
    axios
      .get(`/api/audition-admin/audition-event/for-jury-mark-videos/${slug}`)
      .then((res) => {
        if (res.data.status === 200) {
          let judges_array = [];
          setEvent(res.data.event);
          setActiveRound(res.data.event.active_round_info_id);

          setRounds(res.data.event?.info?.audition_rounds);

          res.data.event.assigned_judges.forEach((judge, index) => {
            let user = judge?.user;
            judges_array.push({
              name: user.first_name + " " + user.last_name,
              id: user.id,
            });
          });
          setJudges(judges_array);
          // setLoading(false);
        }
      });
  };

  useEffect(() => {
    getRoundInstruction();
  }, [activeRound]);

  useEffect(() => {
    getRoundInstruction();
  }, [videoType]);

  useEffect(() => {
    fetchAuditionDetails();
  }, [slug]);

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <div className="container-lg">
          <div>
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey={activeRound}
            >
              <div className="container-lg">
                <Nav variant="pills">
                  <div className="row">
                    {rounds &&
                      rounds.map((auditionRound, index) => (
                        <ReUseableSingleRoundTab
                          key={index}
                          auditionRound={auditionRound}
                          setActiveRound={setActiveRound}
                        />
                      ))}
                  </div>
                </Nav>
                <div className="my-4"></div>
              </div>
            </Tab.Container>
          </div>
          {roundInfo && roundInfo?.has_jury_or_judge_mark === 0 ? (
            <div className="my-3">
              <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Nav variant="pills" className="d-flex justify-content-center">
                  <div className="col-md-md-6 small-live-session mb-3">
                    <Nav.Item>
                      <Nav.Link
                        eventKey="first"
                        className="TabCardGold d-flex  text-decoration-none text-center me-2 fw-bold pt-3 "
                        onClick={handleGeneralVideos}
                      >
                        <h5 className="font-style fw-bold">General Videos</h5>
                      </Nav.Link>
                    </Nav.Item>
                  </div>
                  <div className="col-md-md-6 small-live-session">
                    <Nav.Item>
                      <Nav.Link
                        eventKey="second"
                        className="TabCardGold py-2 fw-bold pt-3 text-decoration-none text-center "
                        onClick={handleAppealedVideos}
                      >
                        <h5 className="font-style fw-bold">Appealed Videos</h5>
                      </Nav.Link>
                    </Nav.Item>
                  </div>
                </Nav>

                <Tab.Content>
                  <Tab.Pane eventKey="first"></Tab.Pane>

                  <Tab.Pane eventKey="second"></Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          ) : (
            <></>
          )}

          <div>
            {roundInfo && roundInfo?.has_jury_or_judge_mark === 0 ? (
              <>
                <AuditionVideoResult
                  videoType={videoType}
                  audition={event}
                  roundInfo={roundInfo != null ? roundInfo : ""}
                  roundUsersb={roundUsersb}
                  roundUsersc={roundUsersc}
                  secondaryJuryGroup={secondaryJuryGroup}
                  mainJury={mainJury}
                  isVideoAlreadyAssignedRan={isVideoAlreadyAssignedRan}
                  setIsVideoAlreadyAssignedRan={setIsVideoAlreadyAssignedRan}
                  isVideoAlreadyAssignedPer={isVideoAlreadyAssignedPer}
                  setIsVideoAlreadyAssignedPer={setIsVideoAlreadyAssignedPer}
                />
              </>
            ) : (
              <>
                {roundInfo && roundInfo?.round_type === 1 ? (
                  <AuditionLiveRoundJudgeAssessment
                    tabActiveRound={activeRound}
                  />
                ) : (
                  <>
                    <AuditionRoundJudgeAssessmentResult
                      tabActiveRound={activeRound}
                    />
                  </>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default AuditionJuryMarkedVideoByRound;
